export default {
    // /////////////////////////////////////////////
    // COMMON
    // /////////////////////////////////////////////

    UPDATE_JAVSCRIPT_LIBRARY(state, payload) {
        state.javascriptLibrary = payload.map(item => Object.seal(item));
    },
}